function roundUp(number: number, decimal: number): number {
  const pow = 10 ** decimal;
  const value = Math.round((number + Number.EPSILON) * pow) / pow;
  return value;
}

export default roundUp;
